import { render, staticRenderFns } from "./WFieldSubmit.vue?vue&type=template&id=527794ae&"
import script from "./WFieldSubmit.vue?vue&type=script&lang=ts&"
export * from "./WFieldSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports